import { render, staticRenderFns } from "./SystemInfo.vue?vue&type=template&id=26c17d26&scoped=true"
import script from "./SystemInfo.vue?vue&type=script&lang=js"
export * from "./SystemInfo.vue?vue&type=script&lang=js"
import style0 from "./SystemInfo.vue?vue&type=style&index=0&id=26c17d26&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c17d26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26c17d26')) {
      api.createRecord('26c17d26', component.options)
    } else {
      api.reload('26c17d26', component.options)
    }
    module.hot.accept("./SystemInfo.vue?vue&type=template&id=26c17d26&scoped=true", function () {
      api.rerender('26c17d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/SystemInfo.vue"
export default component.exports